import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEO from '@/components/base/SEO';
import HeroSection from './components/HeroSection';
import HotRecommend from './components/HotRecommend';
import CategorySection from './components/CategorySection';
import LatestUpdate from './components/LatestUpdate';
import Ranking from './components/Ranking';
import CTASection from './components/CTASection';

export default function Home() {
  const homeSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '香香漫画 - 韩漫日漫国漫免费在线阅读',
    description: '香香漫画网，提供海量韩漫日漫国漫免费在线阅读，好看的漫画免费全集大全，下拉式追更体验，安全直达。',
    url: 'https://www.xiangxiangmh.com',
    isPartOf: {
      '@type': 'WebSite',
      name: '香香漫画',
      url: 'https://www.xiangxiangmh.com',
    },
  };

  return (
    <>
      <SEO
        title="香香漫画 - 香香漫画网：香香漫画官网入口与网址，韩漫日漫国漫免费在线阅读"
        description="香香漫画网，提供香香漫画官网入口与网址，海量韩漫日漫国漫免费在线阅读，好看的漫画免费全集大全，下拉式追更体验，安全直达。"
        keywords="香香漫画,香香漫画网,香香漫画官网入口,香香漫画网址,韩漫免费阅读,日漫,国漫,漫画全集,下拉式,追更,好看的漫画,免费漫画大全"
        canonicalUrl="https://www.xiangxiangmh.com"
        ogType="website"
        ogImage="https://readdy.ai/api/search-image?query=Manga%20reading%20website%20homepage%20featuring%20various%20comic%20book%20covers%20in%20warm%20inviting%20tones%2C%20stylized%20illustration%2C%20cozy%20atmosphere&width=1200&height=630&seq=og-home-2026&orientation=landscape"
        schema={homeSchema}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <HotRecommend />
        <CategorySection />
        <LatestUpdate />
        <Ranking />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}